import { useMemo } from 'react';
import { ILabelledStateAwareArea, IStateAwareArea } from 'types/map';

export default function useLabelledAreas(areas: IStateAwareArea[]) {
  return useMemo(() => areas.filter(a => a.isLabelled).map(a => a as ILabelledStateAwareArea), [areas]);
}